import './OfflineNotification.css'

import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'

import useOfflineStatus from './useOfflineStatus'

function OfflineNotification() {
  const { t: translate } = useTranslation()
  const { offline } = useOfflineStatus()

  return <Box className={classNames('offline-notification', { offline })}>{translate('common.noInternetConnection')}</Box>
}

export default OfflineNotification
